// extracted by mini-css-extract-plugin
export var container = "_da-1";
export var cornerButtonContainer = "_da-6";
export var disabled = "_da-2";
export var dragActive = "_da-3";
export var fileContainer = "_da-5";
export var hiddenInput = "_da-4";
export var widthContainer = "_da-0";